export const MODES = [
  { id: 'opening', label: 'Opening' },
  { id: 'horse-ride', label: 'Horse Ride' },
  { id: 'tactic-alert', label: 'Tactic Alert' },
  { id: 'blindfold', label: 'Blindfold' },
  { id: 'mating', label: 'Checkmate' },
] as const;

export type ModeId = (typeof MODES)[number]['id'];

export const MODE_IDS: ModeId[] = MODES.map((m) => m.id);

export function isModeId(value: string): value is ModeId {
  return (MODE_IDS as string[]).includes(value);
}
